import React, { Component } from "react";

class YouTube extends Component {
  render() {
    return (
      <div
        style={{
          position: "relative",
          paddingBottom: "56.25%",
          height: "0",
          overflow: "hidden",
          maxWidth: "100%"
        }}
      >
        <iframe
          title={this.props.title}
          src={this.props.url}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen="allowfullscreen"
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%"
          }}
        ></iframe>
      </div>
    );
  }
}

export default YouTube;
